import React from 'react'
import styled from 'styled-components';
import { mobile } from '../responsive';

import {Copyright, 
        Facebook, 
        Instagram, 
        Twitter, 
        Phone, 
        LocationOn, 
        MailOutline} from '@material-ui/icons';

const Container = styled.div`
    width: 100%;
    min-height: ${props => props.pfVersion ? '3vh' : '10vh'};
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: lightgreen;
    padding: 5px 0;
    border-radius: 0 0 5px 5px;
    ${mobile({ flexDirection: 'column',
                justifyContent: 'space-around'
            
            })};
`



const CopyrightText = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    margin-right: 20px;
    justify-content: ${props => props.pfVersion ? 'center' : 'flex-end' };
    color: gray;
    font-size: 15px
    
`
const SocialIcons = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 20px;
    ${mobile({  
                display: 'none'
            })};
    
`
const SocialIcon = styled.div`
    width: 40px;
    height: 40px;
    
    color: white;
    background-color: #${(props) => props.color};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
    border-radius: 15px;
    box-shadow: 5px 5px 10px rgba(9, 148, 255, 0.25), 
                -2px -2px 5px rgba(9, 148, 255, 0.05), 
                inset -2px -2px 5px rgba(9, 148, 255, 0.25);
    
`
const AddressContainer = styled.div`
    flex: 3;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 15px;
    ${mobile({  
                display: 'none'
            })};
    
`
const AddressItem = styled.p`
    margin: 0;
    display: flex;
    align-items: center;
    color: gray;
    padding: 2px;
`

const Footer = ({pfVersion}) => {
    return (
        <>
        {!pfVersion ? ( <Container>
            <SocialIcons>
            <SocialIcon color="3B5999"><Facebook /></SocialIcon>
            <SocialIcon color="E4405F"><Instagram /></SocialIcon>
            <SocialIcon color="55ACEE"><Twitter /></SocialIcon>
            </SocialIcons>
            <AddressContainer>
            <AddressItem> <LocationOn style={{marginRight:"10px"}} /> 14, Idowu Martins Str, VI, Lagos </AddressItem>
            <AddressItem> <MailOutline style={{marginRight:"10px"}} /> info@megaplaza.com.ng</AddressItem>
            <AddressItem><Phone style={{marginRight:"10px"}} /> +123456789</AddressItem>
            </AddressContainer> 
            <CopyrightText>
                <Copyright style={{marginRight:"5px"}}/> KNCTech 2022
            </CopyrightText>
    
            </Container> ) : 
            ( <Container pfVersion = {pfVersion}>
                <CopyrightText pfVersion = {pfVersion}>
                    <Copyright style={{marginRight:"5px"}}/> Generated By KNC Tech PV Generator 2022
                </CopyrightText>
                </Container> ) }
        </>
    )
}

export default Footer
